<ng-container *ngIf="currentDetailPage$ | async as fullPage">
  <section class="banner" *ngIf="fullPage.banner">
    <img [src]="fullPage.banner?.url" [alt]="fullPage.title" />
  </section>
  <h1>{{ fullPage.title }}</h1>
  <section class="intro">
    <lacerta-rich-text-block [content]="fullPage.intro"></lacerta-rich-text-block>
  </section>
</ng-container>
